import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "typespec",
  extensions: [".tsp"],
  aliases: ["TypeSpec"],
  loader: () => import('./typespec.js')
});
